import { numberFormat } from '@/common/format';

const getSqftNum = (info) => {
    let value1 = info.sqft;
    let value2 = info.totalAvailableAcres;
    if (value1 > 0) {
        return numberFormat(value1, false, 2);
    }
    //totalAvailableAcres>0
    if (value2 >= 10890) {
        return numberFormat(value2 / (10890 * 4), false, 2);
    }
    return numberFormat(value2, false, 2);
}

export const getCountObj = function(info)  {
    let result = {};
    if (info.bedrooms > 0) {
        result.bedrooms = {
            num: numberFormat(info.bedrooms, false, 2),
            unit: this.$t('md-detail-info.bed', { count: info.bedrooms })
        }
    }
    if (info.bathrooms > 0) {
        result.bathrooms = {
            num: numberFormat(info.bathrooms, false, 2),
            unit: this.$t('md-detail-info.bath', { count: info.bathrooms })
        }
    }
    if (info.sqft > 0 || info.totalAvailableAcres > 0) {
        let unit = '';
        let value1 = info.sqft;
        let value2 = info.totalAvailableAcres;
        if (value1 > 0) {
            unit = this.$t('md-detail-info.sqft');
        } else if (value2 >= 10890) {
            unit = this.$t('md-detail-info.acresLot');
        } else if (value2 > 0 && value2 < 10890) {
            unit =  this.$t('md-detail-info.sqftLot');
        }
        result.sqft = {
            num: getSqftNum(info),
            unit
        }
    }
    return result;
}

